module.exports = __webpack_public_path__ + "img/commentary-hover.efe64fe7.png";